import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "bs-sidebar-link__container" }
const _hoisted_2 = { class: "container__icon" }
const _hoisted_3 = {
  key: 0,
  class: "container__name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
    ref: "reference",
    class: "bs-sidebar-link",
    onMouseover: _ctx.onOpenTooltip,
    onMouseleave: _ctx.close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "icon")
        ]),
        (_ctx.opened)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, { name: "m-tooltip" }, {
          default: _withCtx(() => [
            (_ctx.isVisible)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "bs-m-tooltip tooltip--base",
                  ref: "tooltip",
                  style: _normalizeStyle({ position: _ctx.strategy, left: `${_ctx.x}px`, top: `${_ctx.y}px` })
                }, [
                  _renderSlot(_ctx.$slots, "default")
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ]))
    ]),
    _: 3
  }, 40, ["onMouseover", "onMouseleave"]))
}